<!--<div class="relative w-full overflow-hidden hidden md:block">
    <img src="assets/img/internalBanner(PROGRAMS)/Graduate.webp" alt="Graduate Programs Desktop Image"
         class="w-full h-auto object-contain">
</div>

<div class="relative w-full overflow-hidden flex md:hidden">
    <img src="assets/img/program-mobile-banners/Graduate.webp" alt="Mobile Image" class="w-full h-auto object-contain">
</div>-->
<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/internalBanner(PROGRAMS)/Graduate.webp">
        <source media="(min-width:768px)" srcset="assets/img/internalBanner(PROGRAMS)/medium-screen/Graduate.webp">
        <img
            src="assets/img/program-mobile-banners/Graduate.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>




<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <!--        <aside class="w-full lg:w-1/4 space-y-4 max-h-screen overflow-y-auto overflow-x-hidden pr-2">-->
        <!--            <div class="flex flex-row lg:flex-col space-x-4 lg:space-x-0 lg:space-y-4 min-w-max">-->
        <!--                &lt;!&ndash; Card 1 &ndash;&gt;-->
        <!--                <div class="border-t-8 border-blue-400 min-w-[300px]">-->
        <!--                    <div class="bg-white shadow border border-gray-300">-->
        <!--                        <h2 class="text-lg font-bold p-4">Program Type</h2>-->
        <!--                        <div>-->
        <!--                            <a href="/programs/graduate"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full bg-blue-600 text-white border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Graduation</span>-->
        <!--                            </a>-->
        <!--                            <a href="/programs/post-graduate"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Post Graduation</span>-->
        <!--                            </a>-->
        <!--                            <a href="/programs/doctoral"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Doctoral</span>-->
        <!--                            </a>-->
        <!--                            <a href="/programs/diploma"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Diploma</span>-->
        <!--                            </a>-->
        <!--                            <a href="/programs/integrated"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Integrated</span>-->
        <!--                            </a>-->
        <!--                            <a href="/programs/certificate"-->
        <!--                               class="flex items-center space-x-2 p-3 w-full text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">-->
        <!--                                <i class="fa fa-arrow-right"></i><span>Certificate</span>-->
        <!--                            </a>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                &lt;!&ndash; Quick Links Heading &ndash;&gt;-->
        <!--                <h2 class="text-lg font-semibold mb-4 min-w-[300px]">Quick Links</h2>-->

        <!--                &lt;!&ndash; Card 2 &ndash;&gt;-->
        <!--                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2 min-w-[300px]">-->
        <!--                    <div class="space-y-2">-->
        <!--                        <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">-->
        <!--                          <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">-->
        <!--                                <i class="fa fa-comment text-2xl"></i>-->
        <!--                          </span>-->
        <!--                            <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>-->
        <!--                        </a>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                &lt;!&ndash; Card 3 &ndash;&gt;-->
        <!--                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2 min-w-[300px]">-->
        <!--                    <div class="space-y-2">-->
        <!--                        <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">-->
        <!--                          <span-->
        <!--                              class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">-->
        <!--                            <i class="fa fa-calendar text-2xl"></i>-->
        <!--                          </span>-->
        <!--                            <span class="text-gray-700 font-medium text-xl pl-4">What's Happening</span>-->
        <!--                        </a>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                &lt;!&ndash; Card 4 &ndash;&gt;-->
        <!--                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2 min-w-[300px]">-->
        <!--                    <div class="space-y-2">-->
        <!--                        <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg">-->
        <!--          <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">-->
        <!--            <i class="fa fa-phone text-2xl"></i>-->
        <!--          </span>-->
        <!--                            <span class="text-gray-700 font-medium text-xl pl-4">Contact Us</span>-->
        <!--                        </a>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                &lt;!&ndash; Card 5 &ndash;&gt;-->
        <!--                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2 min-w-[300px]">-->
        <!--                    <div class="space-y-2">-->
        <!--                        <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg">-->
        <!--          <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">-->
        <!--            <i class="fa fa-camera text-2xl"></i>-->
        <!--          </span>-->
        <!--                            <span class="text-gray-700 font-medium text-xl pl-4">Image Gallery</span>-->
        <!--                        </a>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </aside>-->

        <aside class="w-full lg:w-1/4 space-y-4 lg: max-h-screen lg:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Programme Type</h2>
                    <div class="">

                        <a href="/programs/graduate"
                           class="flex items-center space-x-2 p-3 w-full bg-blue-600 text-white border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Graduation</span>
                        </a>
                        <a href="/programs/post-graduate"
                           class="flex items-center space-x-2 p-3 w-full text-blue-600 border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Post Graduation</span>
                        </a>
                        <a href="/programs/doctoral"
                           class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Doctoral</span>
                        </a>
                        <a href="/programs/diploma"
                           class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Diploma</span>
                        </a>
                        <a href="/programs/integrated"
                           class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Integrated</span>
                        </a>
                        <a href="/programs/certificate"
                           class="flex items-center space-x-2 p-3 w-full text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Certificate</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow  hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                               <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-xl pl-4">What's Happening</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Contact Us</span>
                    </a>
                </div>
            </div>

          <!--  <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Image Gallery</span>
                    </a>
                </div>
            </div>-->
        </aside>

        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div *ngFor="let card of cards" class="bg-white p-4 rounded-lg shadow border">
                    <div class="h-[100px]">
                        <div class="flex justify-between items-center">
                            <h3 class="text-lg font-semibold">{{ card.title }}</h3>
                            <i [class]="card.icon + ' text-gray-500'"></i>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-500 my-2">{{ card.subheading }}</h3>
                    </div>
                    <hr class="my-2">
                    <div class="flex  justify-between items-center">
                        <span>
                        <p class="text-gray-600">Programs: {{ card.programs }}</p>
                        <p class="text-gray-600">Course: {{ card.course }}</p>
                        <p *ngIf="card.specialization" class="text-gray-600">
                            Specialization: {{ card.specialization }}</p>
                            </span>
                        <button class="text-blue-400 flex items-center" (click)="goTo(card?.url)">
                            More
                            <span
                                class="w-6 h-6 flex items-center justify-center bg-white text-blue-400 border-2 border-blue-400 rounded-full ml-1">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </section>

    </div>
</div>
